// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-39afaea6] button.dropdown-toggle.btn-link {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
